import styles from './CancelRenewSection.module.scss';
import { useSubscriptionInfo, useVisible } from 'src/hooks';
import {
  DrawerTooltipContainer,
  DrawerTooltipContainerRef,
} from 'src/v2/commonComponents/DrawerTooltipContainer';
import { useMemo, useRef } from 'react';
import { CancelSubscriptionButton } from 'src/v2/pages/subscription/components/CancelSubscription/components/CancelSubscriptionButton';
import { MoreOptionsToggle } from 'src/v2/pages/subscription/components/MoreOptionsToggle';
import { RenewSubscriptionButton } from 'src/v2/pages/subscription/components/RenewSubscriptionButton';
import { CancelSubscriptionModal } from '../CancelSubscription/components/CancelSubscriptionModal/CancelSubscriptionModal';
import dayjs from 'dayjs';
import { PAYMENTS_DATE_FORMAT } from 'src/constants';

const tooltipAnchorId = 'cancel-subscription-button-tooltip-anchor';

export const CancelRenewSection = () => {
  const {
    isVisible: isModalVisible,
    onVisibilityRemove: onModalClose,
    onVisibilitySet: onModalOpen,
  } = useVisible();

  const { subscriptionInfo, isAppleOrAmpPayment, isSubscriptionInfoLoading } =
    useSubscriptionInfo();

  const drawerRef = useRef<DrawerTooltipContainerRef>(null);

  const cancellationDate = useMemo(() => {
    return dayjs(subscriptionInfo?.curr_period_end_timestamp).format(
      PAYMENTS_DATE_FORMAT,
    );
  }, [subscriptionInfo?.curr_period_end_timestamp]);

  const handleSubscriptionModalClose = () => {
    drawerRef.current?.onVisibilityToggle();
    onModalClose();
  };

  return (
    <div className={styles.root}>
      <CancelSubscriptionModal
        isOpen={isModalVisible}
        onClose={handleSubscriptionModalClose}
        cancellationDate={cancellationDate}
        planKind={subscriptionInfo?.plan_kind}
      />

      {!subscriptionInfo?.is_cancelled && (
        <DrawerTooltipContainer
          ref={drawerRef}
          id={tooltipAnchorId}
          place="bottom-start"
          ToggleButton={MoreOptionsToggle}
          onlyTooltip
          classNameDrawer={styles.root}
        >
          <div className={styles.container}>
            <CancelSubscriptionButton
              subscriptionInfo={subscriptionInfo}
              isSubscriptionInfoLoading={isSubscriptionInfoLoading}
              isAppleOrAmpPayment={isAppleOrAmpPayment}
              onClick={onModalOpen}
            />
          </div>
        </DrawerTooltipContainer>
      )}
      {subscriptionInfo?.is_cancelled && (
        <RenewSubscriptionButton
          subscriptionInfo={subscriptionInfo}
          isAppleOrAmpPayment={isAppleOrAmpPayment}
          isSubscriptionInfoLoading={isSubscriptionInfoLoading}
        />
      )}
    </div>
  );
};
